<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ $t('meta.editGenre') }}</span>
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="updateGenre" ref="form">
        <v-text-field v-model="editedGenre.name" :label="$t('meta.name')" required></v-text-field>
        <v-text-field v-model.number="editedGenre.genre_index" :label="$t('meta.index')" type="number" required></v-text-field>
        <v-text-field v-model="editedGenre.code" :label="$t('meta.code')" required></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="closeDialog">{{ $t('meta.cancel') }}</v-btn>
      <v-btn color="blue darken-1" text @click="updateGenre">{{ $t('meta.save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import axios from 'axios'
import {useI18n} from 'vue-i18n'

const {t: $t} = useI18n()

const props = defineProps(['genre'])
const emit = defineEmits(['close', 'genre-updated'])

const editedGenre = ref({})

onMounted(() => {
  editedGenre.value = {
    id: props.genre.id,
    name: props.genre.name,
    genre_index: props.genre.genre_index,
    code: props.genre.code
  }
})
async function updateGenre() {
  try {
    await axios.put(`/api/genres/${editedGenre.value.id}`, editedGenre.value)
    emit('genre-updated')
    closeDialog()
  } catch (error) {
    console.error('Error updating genre:', error)
  }
}

function closeDialog() {
  emit('close')
}
</script>